import { render, staticRenderFns } from "./BeerCard.vue?vue&type=template&id=47336034&scoped=true&lang=html&"
import script from "./BeerCard.vue?vue&type=script&lang=js&"
export * from "./BeerCard.vue?vue&type=script&lang=js&"
import style0 from "./BeerCard.vue?vue&type=style&index=0&id=47336034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47336034",
  null
  
)

export default component.exports